import {BriefcaseIcon, EnvelopeIcon, MapIcon, PhoneIcon} from '@heroicons/react/24/outline'
import {SelectField, TextArea, TextField} from "@/components/Fields";
import {Button} from "@/components/Button";
import office from '@/images/office.jpg';
import Image from "next/image";

export default function Office() {
    return <div className="relative bg-white">
        <div className="lg:absolute lg:inset-0">
            <div className="lg:absolute lg:inset-y-0 lg:right-0 lg:w-1/2">
                <Image
                    className="h-56 w-full object-cover lg:absolute lg:h-full"
                    src={office}
                    alt="Kantoor"
                />
            </div>
        </div>
        <div className="relative py-16 px-6 sm:py-24 lg:mx-auto lg:grid lg:max-w-7xl lg:grid-cols-2 lg:px-8 lg:py-32">
            <div className="lg:pr-8">
                <div className="mx-auto max-w-md sm:max-w-lg lg:mx-0">
                    <div>
                        <h2 className="text-2xl font-bold text-gray-900 sm:text-3xl sm:tracking-tight font-display">Bedrijfsgegevens</h2>
                        <div className="mt-3">
                            <p className="text-lg text-gray-500">
                                Graag een keer langskomen? Wij zijn gevestigd in &apos;s-Hertogenbosch.
                            </p>
                        </div>
                        <div className="mt-9">
                            <div className="flex">
                                <div className="flex-shrink-0">
                                    <MapIcon className="h-6 w-6 text-gray-400" aria-hidden="true"/>
                                </div>
                                <div className="ml-3 text-base text-gray-500">
                                    <p className="font-semibold">The Lobby</p>
                                    <p className="mt-1">Reitscheweg 1</p>
                                    <p className="mt-1">&apos;s-Hertogenbosch</p>
                                    <p className="mt-1">5232 BX</p>
                                </div>
                            </div>
                            <div className="mt-6 flex">
                                <div className="flex-shrink-0">
                                    <BriefcaseIcon className="h-6 w-6 text-gray-400" aria-hidden="true"/>
                                </div>
                                <div className="ml-3 text-base text-gray-500">
                                    <p>KVK: 87979284</p>
                                    <p className="mt-1">BTW: NL864465695B01</p>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>
}
